import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import AIAssistant from "@/components/AIAssistant";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col grain">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
      <AIAssistant />
    </div>
  );
}
